export const MEDIUM_NARROW_WIDTH_PX = 792;

export const GLOBAL_NAV_DESKTOP_MIN_WIDTH_PX = 835;

export const GLOBAL_NAV_COMPACT_MAX_WIDTH_PX = GLOBAL_NAV_DESKTOP_MIN_WIDTH_PX - 1;

export const GLOBAL_NAV_COLLAPSED_SEARCH_MAX_WIDTH_PX = MEDIUM_NARROW_WIDTH_PX - 1;
